<template>
  <span class="device-status">
    <font-awesome-icon
      class="device-status-icon"
      icon="circle"
      :style="{ color }"
    /> {{ stateText }}
  </span>
</template>

<script>
export default {
  name: 'WatchState',
  props: {
    location: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      color: '',
      stateText: ''
    }
  },
  watch: {
    location: {
      handler () {
        this.setStatus()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    setStatus () {
      if (!this.location || !this.location?.lat?.time) {
        this.color = 'rgba(20,20,20,0.2)'
        this.stateText = 'Не отслеживается'
        return
      }

      const date = new Date(this.location.lat.time)
      const diffMin = Math.floor((Date.now() - date) / 60000)

      if (diffMin == 0) {
        this.color = '#43E872'
        this.stateText = 'Недавно'
        return
      }

      if (diffMin < 60) {
        this.stateText =  `${diffMin}м. назад`
      } else {
        const h = Math.floor(diffMin / 60)
        const d = Math.floor(h / 24)
        const m = diffMin % 60
        this.stateText =  h >= 120 ? `${d} дней назад` : `${h}ч. ${m}м. назад`
      }

      this.color = diffMin < 60 ? '#E8CF72' : '#E95B5A'
    }
  }
}
</script>
